
export const copyToClipboard = (str: string) => {
    navigator.clipboard.writeText(str);
}

export const debounce = (func: any, timeout: number = 300) => {
    let timer = undefined as any
    return (...args: any) => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            func.apply(this, args)
        }, timeout)
    }
}

export const deepCopy = (obj: any) => JSON.parse(JSON.stringify(obj))

export const deepCopyAndApply = (obj: any, apply: (o: any) => void) => {
    const copy = JSON.parse(JSON.stringify(obj))
    apply(copy)
    return copy
}
